import { render, staticRenderFns } from "./AdminChatAddForm.vue?vue&type=template&id=3647a254&"
import script from "./AdminChatAddForm.vue?vue&type=script&lang=js&"
export * from "./AdminChatAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports